module.exports = __webpack_public_path__ + "img/header-engagementRingsWhitegold@2x.ade6633.jpg";